"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVisibleAttempts = exports.isVisibleAtReports = void 0;
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
/**
 * isVisibleAtReports
 *
 * @param {Attempt}   attempt    - Attempt object
 *
 * Returns attempts visible
 */
var isVisibleAtReports = function (attempt) {
    var assessment = attempt.assessment, _a = attempt.assessment.settings.scores, scores = _a === void 0 ? {} : _a;
    var hasScoreSettings = !(0, isUndefined_1.default)(scores) &&
        !(0, isUndefined_1.default)(scores.showWhenStudentSubmitted) &&
        !(0, isUndefined_1.default)(scores.showWhenClassSubmitted) &&
        !(0, isUndefined_1.default)(scores.showWhenClassDone);
    var whenStudentSubmitted = scores.showWhenStudentSubmitted || false;
    var whenClassSubmitted = scores.showWhenClassSubmitted || false;
    var whenDone = (scores.showWhenClassDone && assessment.isDone) || false;
    return hasScoreSettings && (whenStudentSubmitted || whenClassSubmitted || whenDone);
};
exports.isVisibleAtReports = isVisibleAtReports;
/**
 * getVisibleAttempts
 *
 * @param {object}   attempts[]     - Attempt List
 *
 * Returns an array with attempts visible at reports
 */
var getVisibleAttempts = function (attempts) { return attempts.filter(exports.isVisibleAtReports); };
exports.getVisibleAttempts = getVisibleAttempts;
